import { InsightsOutlined as BiDashboardIcon } from '@mui/icons-material';
import type { ReactNode } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import { IconAnalyticsDashboard } from '~/ui/core/icons';

import { SideDrawerLinkV2 } from '../../app-bar/menu-bar-v2/SideDrawerLinkV2';
import { route as dashboardV2PageRoute } from './constants';

export const useDashboardV2ListItem = (): ReactNode => {
    const {
        applicationState: { featureFlagService },
        translate,
    } = useContext(ApplicationContext);

    if (!featureFlagService.isFeatureFlagEnabled('dashboard-v2')) {
        return null;
    }

    const isDemoMenuEnabled = featureFlagService.isFeatureFlagEnabled('demo-menu');
    const label = isDemoMenuEnabled ? translate('navigation.dashboard') : translate('navigation.dashboard-v2');

    return (
        <SideDrawerLinkV2
            externalUrl={false}
            Icon={BiDashboardIcon}
            label={label}
            NewIcon={IconAnalyticsDashboard}
            path={dashboardV2PageRoute.patterns.dashboardV2}
        />
    );
};
